const strings = {
  MANDATORY_FIELD: 'Fältet är oblikatoriskt',
  LAUNDRY_UPDATED: {
    S: 'Tvättstugan har uppdaterats',
    M: 'Tvättmaskinen har uppdaterats'
  },
  INTERNAL_ERROR: 'Ett oväntat fel har uppstått, var god försök igen.',
  EDIT_LAUNDRY: {
    S: 'Ändra tvättstuga',
    M: 'Ändra tvättmaskin'
  },
  EDIT_LAUNDRY_INFORMATION: {
    S: 'Välj ett nytt namn eller sätt din tvättstuga ur funktion.',
    M: 'Välj ett nytt namn eller sätt din tvättmaskin ur funktion.'
  }
}

export default strings



// WEBPACK FOOTER //
// ./src/components/containers/EditLaundryModal/strings.js